import React, { useState, useEffect } from 'react';
import CreateForm from '../../components/Tasks/CreateForm';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import { grey } from '@mui/material/colors';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import useApiManager from '../../utils/Api/apiManager';
import { useParams } from 'react-router-dom';
import EditUser from '../../components/Users/EditForm';

const EditUserPage = () => {
    const [userData, setUserData] = useState(null)
    const navigate = useNavigate();
    const { get, put } = useApiManager();
    const { userId } = useParams();
    const [loading, setLoading] = useState(true);

    const fetchUserData = async () => {
        try {
            const data = await get(`/users/${userId}`);
            setUserData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (userId) {
            fetchUserData();
        }
    }, [userId]);

    const handleFormSubmit = async (formData) => {
        //console.log('Form Submitted:', formData);
        // Handle form submission logic here (e.g., send data to an API)
        try {
            const responseData = await put(`/users/${userId}`, formData);
            navigate('/admin');
            // Handle success (e.g., show a notification, redirect, etc.)
        } catch (error) {
            console.error('Failed to submit form:', error);
            // Handle error (e.g., show an error message)
        }
    };

    useEffect(() => {
        document.title = "Edit User - iLead CRM";
    }, []);

    return (
        <Box sx={{ p: 5 }}>
            <Paper elevation={3} sx={{ p: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px' }}>
                    <h3>Edit User</h3>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        <Link to="/admin">
                            <Button variant="outlined">Cancel</Button>
                        </Link>
                        <Button variant="contained" type="submit" form="create-form" >Save</Button>
                    </Box>
                </Box>
                <Divider aria-hidden="true" sx={{ borderWidth: "thin" }} />
                <EditUser onSubmit={handleFormSubmit} userData={userData} />
            </Paper >
        </Box>
    )
}
export default EditUserPage;